import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  createProduct,
  deleteProduct,
  updateproduct,
} from "../graphQL/graphMutation";
import URL from "../../pages/Utils/url";
import axios from "axios";

export const addProductService = async (values) => {
  let createStatus = false;
  try {
    const res = await request(BASEURL, createProduct, {
      input: {
        ...values,
      },
    });
    createStatus = true;
  } catch (err) {
    console.error(err.message, "addProduct error");
  }

  return createStatus;
};

export const addProductRestService = async (formdata) => {
  let createStatus = false;
  let errormessage;
  try {
    const response = await axios.post(
      `${URL}product/newProductAdd/`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    createStatus = true;
  } catch (err) {
    console.error(err, "errr");
  }
  return {createStatus,errormessage};
};

export const updateProductRestService = async (formData, id) => {
  let createStatus = false;
  try {
    const response = await axios.put(
      `${URL}product/newProductAdd/${id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    createStatus = true;
  } catch (err) {
    console.error(err.message);
    createStatus = false;
  }
  return createStatus;
};

export const updateProductService = async (values, id) => {
  let status = false;
  try {
    const res = await request(BASEURL, updateproduct, {
      input: {
        id: id,
        ...values,
      },
    });
    status = true;
  } catch (err) {
    console.error(err.message);
    status = false;
  }
  return status;
};

export const deleteProductService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteProduct, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteProduct error");
    delteStatus = false;
  }
  return delteStatus;
};
